/**
 * @Date: 2020-06-01 13:57
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 */
import M from 'ant-design-vue/es/modal/Modal'
import { getDefaultProps } from '../../_utils'

export default {
  canUse: false,
  // name: 'EditorModal',
  name: 'TODO',
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: Object.assign({}, M.props, {}),
  data () {
    return {
      isVisible: this?.visible || true
    }
  },
  methods: {},
  render () {
    const defaultProps = getDefaultProps(M.props, this)
    return (
      <a-modal {...{ defaultProps }} {...{ on: this.$listeners }} vModel={this.isVisible}>
        {Object.keys(this.$slots).map(name => (<template slot={name}>{this.$slots[name]}</template>))}
      </a-modal>
    )
  }
}
